export default {
    highlight(text, searchTerm, styleObject) {
        if (!searchTerm) {
            return text;
        }

        // Need to escape any special characters before passing the search value to RegExp
        // eslint-disable-next-line
        const escape = string => string.replace(/[-\\\/^$*+?.()|[\]{}]/g, '\\$&');

        return text.replace(new RegExp(escape(searchTerm), 'gi'), match => {
            return `<span class="${styleObject['mds-combo-box--text-match']}">${match}</span>`;
        });
    },
};
